var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_568",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4F8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_568)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M407.247 270.344C348.229 280.935 324.05 242.349 232.506 271.305C159.51 294.393 120.89 247.78 107.577 217.462C101.221 202.976 92.609 144.294 133.507 138.237C272.295 117.64 364.397 -49.0123 448.448 75.7855C482.54 126.413 541.225 246.281 407.247 270.344Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9 286.779C396.9 286.779 396.985 286.847 397.036 286.881C401.176 289.969 403.5 294.923 403.5 300.081V342.124C403.5 355.104 354.144 365.64 293.25 365.64C232.356 365.64 183 355.104 183 342.124V304.95C183 298.299 185.341 291.869 189.6 286.779",
    fill: "#64ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.251 315.452C351.929 315.452 399.497 304.923 399.497 291.936C399.497 278.948 351.929 268.42 293.251 268.42C234.573 268.42 187.005 278.948 187.005 291.936C187.005 304.923 234.573 315.452 293.251 315.452Z",
    fill: "#BFDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.39 254.066C378.39 254.066 378.458 254.117 378.492 254.151C381.885 256.696 383.802 260.751 383.802 264.993V287.287C383.802 297.959 343.252 306.595 293.251 306.595C243.25 306.595 202.699 297.942 202.699 287.287V268.997C202.699 263.534 204.616 258.257 208.112 254.066",
    fill: "#64ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.249 277.616C341.442 277.616 380.509 268.972 380.509 258.308C380.509 247.645 341.442 239 293.249 239C245.057 239 205.989 247.645 205.989 258.308C205.989 268.972 245.057 277.616 293.249 277.616Z",
    fill: "#BFDDFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced4);
export default __webpack_public_path__ + "static/media/bg-advanced4.c7f056e3b81ef124843e515e34da8131.svg";
export { ForwardRef as ReactComponent };